import classnames from 'classnames'
import React, { useRef, useState } from 'react'
import { Image } from '../../elements/Image'
import { RichText } from '../../elements/RichText'
import { DefaultSizeOptions, Text } from '../../elements/Text'
import { WistiaVideo } from '../../elements/WistiaVideo'
import playIcon from '../../images/play.svg'
import { IProps } from './index'
import styles from './styles.scss'

export function CustomerStoryHero({
  eyebrow,
  heading,
  subheading,
  image,
  video,
  wistiaId,
}: IProps) {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef<HTMLVideoElement | null>(null)

  function playVideo() {
    setIsPlaying(true)
    videoRef.current?.play()
  }

  const heroClassNames = classnames('customer-story-hero', {
    'customer-story-hero--video': !!video,
  })

  return (
    <div className={heroClassNames}>
      <div className="customer-story-hero__wrapper">
        <div className="customer-story-hero__content">
          {eyebrow && (
            <div className="customer-story-hero__eyebrow">
              <Text brand="default" size="eyebrows">
                {eyebrow}
              </Text>
            </div>
          )}
          <h1 className="customer-story-hero__heading">
            <Text brand="default" size={'heading-1-small' as DefaultSizeOptions}>
              {heading}
            </Text>
          </h1>
          {subheading && !video && (
            <div className="customer-story-hero__subheading">
              <RichText document={subheading} />
            </div>
          )}
        </div>
        <div className="customer-story-hero__asset-container">
          <div className="customer-story-hero__asset">
            {wistiaId ? (
              <WistiaVideo wistiaId={wistiaId} title={eyebrow ? eyebrow : ''} />
            ) : video ? (
              // eslint-disable-next-line
              <video ref={videoRef} src={video} poster={image.url} controls={isPlaying} />
            ) : (
              <Image {...image} borderRadius={25} />
            )}
            {video && !isPlaying && (
              // eslint-disable-next-line
              <img
                src={playIcon}
                className="customer-story-hero__play-icon"
                onClick={playVideo}
                aria-label="Play video"
                // eslint-disable-next-line
                tabIndex={0}
              />
            )}
          </div>
        </div>
        {subheading && video && (
          <div className="customer-story-hero__subheading">
            <RichText document={subheading} />
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
